'use client';

import { useLayoutEffect } from 'react';

export function UiToolScrollToTopOnMount() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return null;
}
